import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import cx from 'classnames2';
import { merge } from 'lodash';
import React from 'react';
import { FilterRenderer } from '../Filters';
import styles from './AgGridTable.scss';
import { CellErrorTypes, cellErrorTypeText, IconCellRenderer } from './CellRenderers';
import { InteractiveColumnHeader, StaticColumnHeader } from './ColumnHeaders';
import { CustomLoadingOverlay } from './CustomLoadingOverlay';
import { Tooltip } from './Tooltip';
import { applyMoveToCell, handleTableKeydown } from './utils/a11yUtils';
/* tslint:disable */

LicenseManager.setLicenseKey('CompanyName=OpenGov Inc,LicensedApplication=OpenGov Cloud Platform,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=12,LicensedProductionInstancesCount=1,AssetReference=AG-008788,ExpiryDate=29_July_2021_[v2]_MTYyNzUxMzIwMDAwMA==e5ce4fe4fd778fdde895b1a1da95351b');
export var cellRendererSelector = function cellRendererSelector(params) {
  var valueFormatted = params.valueFormatted;

  if (typeof valueFormatted === 'number') {
    return null;
  }

  if (valueFormatted === CellErrorTypes.ZeroDivision || valueFormatted === CellErrorTypes.InvalidDate || valueFormatted === CellErrorTypes.UnexpectedValue) {
    return {
      component: 'IconCellRenderer',
      params: {
        icon: 'status-warning',
        text: cellErrorTypeText[valueFormatted]
      }
    };
  } else if (valueFormatted && valueFormatted.slice(valueFormatted.length - 3) === '...') {
    return {
      component: 'IconCellRenderer',
      params: {
        icon: 'status-info',
        text: valueFormatted
      }
    };
  } else {
    return null;
  }
};
export var makeColumnDef = function makeColumnDef(colDef, options) {
  var columnDef = merge({}, {
    cellStyle: function cellStyle(params) {
      return params.node.rowPinned ? {
        'font-weight': 600
      } : null; // $font-weight-medium
    },
    cellClass: [options.isCondensed ? styles.condensedCell : styles.cell, colDef.isValueColumn ? styles.valueCell : null, colDef.highlight ? styles.highlightedCell : null].filter(function (cellClass) {
      return cellClass;
    }),
    cellRendererParams: {
      isCondensed: options.isCondensed
    },
    headerComponentParams: {
      alignRight: colDef.isValueColumn ? true : false,
      openFilterDropdown: options.handleFilterOpen,
      highlight: colDef.highlight,
      showTooltip: colDef.showTooltip,
      tooltipBody: colDef.tooltipBody
    }
  }, colDef); // Remove our custom props from columnDefs because ag-grid complains in the console that they don't exist

  delete columnDef.isValueColumn;
  delete columnDef.highlight;
  delete columnDef.showTooltip;
  delete columnDef.tooltipBody;
  return columnDef;
};

var makeDefaultColDef = function makeDefaultColDef(defaultColDef) {
  return _objectSpread({
    tooltipComponent: 'Tooltip',
    suppressMovable: true,
    resizable: false,
    cellRendererSelector: cellRendererSelector
  }, defaultColDef);
};

export var AgGridTable = /*#__PURE__*/function (_React$Component) {
  _inherits(AgGridTable, _React$Component);

  var _super = _createSuper(AgGridTable);

  function AgGridTable() {
    var _this;

    _classCallCheck(this, AgGridTable);

    _this = _super.apply(this, arguments);
    _this.state = {
      activeColumnElement: null
    };

    _this.onGridReady = function (params) {
      _this.api = params.api;
      _this.columnApi = params.columnApi;

      if (_this.props.onGridReady) {
        _this.props.onGridReady(params);
      }
    };

    _this.handleFilterOpen = function (columnName, columnElement) {
      if (_this.props.filterProps) {
        _this.setState({
          activeColumnElement: columnElement
        });

        _this.props.onFilterOpened(columnName);
      }
    };

    _this.handleFilterClose = function () {
      _this.setState({
        activeColumnElement: null
      });
    };

    _this.handleScroll = function (params) {
      if (params.direction === 'horizontal' && _this.state.activeColumnElement) {
        _this.handleFilterClose();
      }
    };

    _this.handleGridBodyClick = function (event) {
      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody && !gridBody.contains(event.target)) {
        gridBody.setAttribute('tabIndex', '0');

        if (_this.api) {
          _this.api.clearFocusedCell();
        }
      }
    };

    _this.handleEnterGrid = function () {
      // scrolls to the first row
      _this.api.ensureIndexVisible(0); // scrolls to the first column


      var firstCol = _this.columnApi.getAllDisplayedColumns()[0];

      if (!_this.columnApi.isPinningLeft()) {
        _this.api.ensureColumnVisible(firstCol);
      } // sets focus into the first grid cell


      _this.api.setFocusedCell(0, firstCol);

      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody) {
        gridBody.setAttribute('tabIndex', '-1');
      }
    };

    _this.handleKeyDown = function (gridEvent) {
      var event = gridEvent.event;

      if (event.key === 'Tab') {
        var gridBody = document.querySelector('.ag-body-viewport');

        if (gridBody) {
          gridBody.setAttribute('tabIndex', '0');

          _this.api.clearFocusedCell();

          _this.api.clearRangeSelection();
        }
      }
    };

    _this.makeMoveToCellHandlers = function (index) {
      return function (event) {
        if (event.key === 'ArrowDown') {
          var gridBody = document.querySelector('.ag-body-viewport');

          if (gridBody) {
            gridBody.setAttribute('tabIndex', '-1');
          }

          return handleTableKeydown({
            event: event,
            columnIndex: index,
            gridApi: _this.api,
            columnApi: _this.columnApi,
            isTreeTable: false
          });
        }
      };
    };

    return _this;
  }

  _createClass(AgGridTable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.api) {
        return;
      }

      if (nextProps.showLoadingOverlay !== this.props.showLoadingOverlay) {
        if (nextProps.showLoadingOverlay) {
          this.api.showLoadingOverlay();
        } else {
          this.api.hideOverlay();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody) {
        gridBody.setAttribute('tabIndex', '0');
        gridBody.addEventListener('focus', this.handleEnterGrid);
        window.addEventListener('click', this.handleGridBodyClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var gridBody = document.querySelector('.ag-body-viewport');

      if (gridBody) {
        gridBody.removeEventListener('focus', this.handleEnterGrid);
      }

      window.removeEventListener('click', this.handleGridBodyClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          gridOptions = _this$props.gridOptions,
          width = _this$props.width,
          height = _this$props.height,
          variant = _this$props.variant,
          columnDefs = _this$props.columnDefs,
          rowData = _this$props.rowData,
          filterProps = _this$props.filterProps,
          reactKeyValue = _this$props.reactKeyValue,
          suppressClickEdit = _this$props.suppressClickEdit,
          _this$props$showLoadi = _this$props.showLoadingOverlay,
          showLoadingOverlay = _this$props$showLoadi === void 0 ? false : _this$props$showLoadi,
          processCellForClipboard = _this$props.processCellForClipboard,
          processHeaderForClipboard = _this$props.processHeaderForClipboard,
          processCellFromClipboard = _this$props.processCellFromClipboard,
          processDataFromClipboard = _this$props.processDataFromClipboard;
      var activeColumnElement = this.state.activeColumnElement;
      var colDefsWithKeydownHandlers = columnDefs.map(function (colDef, index) {
        return applyMoveToCell(colDef, _this2.makeMoveToCellHandlers(index));
      });
      return React.createElement("div", {
        "aria-busy": showLoadingOverlay,
        className: cx(styles.openGov, 'ag-theme-balham'),
        style: {
          height: height,
          width: width
        }
      }, React.createElement(AgGridReact, {
        onCellKeyDown: this.handleKeyDown,
        key: reactKeyValue,
        rowData: rowData,
        columnDefs: processColumnDefs(colDefsWithKeydownHandlers, {
          isCondensed: variant === 'condensed',
          handleFilterOpen: filterProps ? this.handleFilterOpen : null
        }),
        // Disable tabbing to navigate cells
        gridOptions: processGridOptions(_objectSpread(_objectSpread({}, gridOptions), {}, {
          tabToNextCell: function tabToNextCell(event) {}
        }), {
          isCondensed: variant === 'condensed',
          handleFilterOpen: filterProps ? this.handleFilterOpen : null
        }),
        onGridReady: this.onGridReady,
        onBodyScroll: this.handleFilterClose,
        processCellForClipboard: processCellForClipboard,
        processHeaderForClipboard: processHeaderForClipboard,
        processCellFromClipboard: processCellFromClipboard,
        processDataFromClipboard: processDataFromClipboard,
        suppressClickEdit: suppressClickEdit,
        ensureDomOrder: true
      }), activeColumnElement && React.createElement(FilterRenderer, Object.assign({
        activeColumnDiv: activeColumnElement,
        onClose: this.handleFilterClose
      }, filterProps)));
    }
  }]);

  return AgGridTable;
}(React.Component);
AgGridTable.defaultProps = {
  gridOptions: {},
  variant: 'default',
  height: '600px',
  width: '100%',
  onFilterOpened: function onFilterOpened() {}
};
export var processColumnDefs = function processColumnDefs(columnDefs, options) {
  return columnDefs.map(function (colDef) {
    var columnDef = colDef;

    if (columnDef.children && columnDef.children.length) {
      columnDef.children = columnDef.children.map(function (col) {
        return makeColumnDef(col, options);
      });
    }

    return makeColumnDef(columnDef, options);
  });
};
export var processGridOptions = function processGridOptions(gridOptions, options) {
  var autoGroupColDef;

  var autoGroupColumnDef = gridOptions.autoGroupColumnDef,
      defaultColDef = gridOptions.defaultColDef,
      otherGridOptions = _objectWithoutProperties(gridOptions, ["autoGroupColumnDef", "defaultColDef"]);

  if (autoGroupColumnDef) {
    autoGroupColDef = makeColumnDef(autoGroupColumnDef, options);
  }

  return merge({
    suppressContextMenu: true,
    animateRows: false,
    enableRangeSelection: false,
    defaultColDef: makeDefaultColDef(defaultColDef),
    rowClass: styles.row,
    rowHeight: options.isCondensed ? 40 : 50,
    headerHeight: 50,
    frameworkComponents: {
      agColumnHeader: StaticColumnHeader,
      CustomLoadingOverlay: CustomLoadingOverlay,
      Tooltip: Tooltip,
      InteractiveColumnHeader: InteractiveColumnHeader,
      StaticColumnHeader: StaticColumnHeader,
      IconCellRenderer: IconCellRenderer
    },
    autoGroupColumnDef: autoGroupColDef
  }, otherGridOptions);
};
export { ColumnApi, GridApi } from 'ag-grid-community';